import { createContext, useReducer, useEffect } from 'react'
import { projectAuth } from '../firebase/config'
import { onAuthStateChanged } from 'firebase/auth'
import { isProvisioned } from '../firebase/provision'

export const AuthContext = createContext()

export const authReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.payload }
    case 'LOGOUT':
      return { ...state, user: null }
    case 'AUTH_IS_READY':
      return { user: action.payload, authIsReady: true }
    default:
      return state
  }
}

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, {
    user: null,
    authIsReady: false,
 })

  useEffect(() => {
    const unsub = onAuthStateChanged(projectAuth, async user => {
      unsub()
      // A restored session is only as good as its provisioning. An account
      // no longer listed in this project's `provision` collection — or one
      // that was only ever provisioned for the Framework Builder — is signed
      // out here instead of being admitted by PrivateRoute on emailVerified
      // alone. See src/firebase/provision.js.
      if (user && !(await isProvisioned(user.email))) {
        await projectAuth.signOut().catch(() => {})
        user = null
      }
      dispatch({ type: 'AUTH_IS_READY', payload: user })
    })
    return () => unsub()
  }, [])


  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      { children }
    </AuthContext.Provider>
  )

}